/* ==========================================================================
   NEO — custom behaviour
   No libraries. The wordmark path is read from the inlined SVG that
   neo-boot.liquid drops into the page, so this file stays small.
   Dawn's own scroll-reveal (settings.animations_reveal_on_scroll) is left
   switched on and reused, so this file adds no scroll observer of its own.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     Which logo animation runs. One word to change: 'draw' | 'glitch' | 'wipe'
     ---------------------------------------------------------------------- */
  var LOGO_ANIM = 'draw';

  var PATH = '';
  var VIEWBOX = '0 0 2856 1458';

  function readSource() {
    var tpl = document.getElementById('neo-logo-svg');
    if (!tpl) return false;
    var root = tpl.content || tpl;
    var svg = root.querySelector('svg');
    if (!svg) return false;
    var path = svg.querySelector('path');
    if (!path) return false;
    PATH = path.getAttribute('d') || '';
    VIEWBOX = svg.getAttribute('viewBox') || VIEWBOX;
    return PATH.length > 0;
  }

  /* ---------------------------------------------------------------------- */
  /* 1. Swap the PNG wordmark for an inline SVG so it can be animated        */
  /* ---------------------------------------------------------------------- */

  function solid() {
    return '<svg class="neo-logo__svg" viewBox="' + VIEWBOX + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
           '<path d="' + PATH + '" fill="currentColor" fill-rule="evenodd"/></svg>';
  }

  function markup(anim) {
    if (anim === 'glitch') {
      return '<span class="neo-logo__base">' + solid() + '</span>' +
             '<span class="neo-logo__slice neo-logo__slice--1">' + solid() + '</span>' +
             '<span class="neo-logo__slice neo-logo__slice--2">' + solid() + '</span>' +
             '<span class="neo-logo__slice neo-logo__slice--3">' + solid() + '</span>';
    }
    if (anim === 'wipe') {
      return '<span class="neo-logo__base">' + solid() + '</span><span class="neo-logo__edge"></span>';
    }
    return '<svg class="neo-logo__svg" viewBox="' + VIEWBOX + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
           '<path class="neo-logo__stroke" d="' + PATH + '" pathLength="1" fill-rule="evenodd"/>' +
           '<path class="neo-logo__fill" d="' + PATH + '" fill="currentColor" fill-rule="evenodd"/></svg>';
  }

  function buildLogo() {
    var img = document.querySelector('.header__heading-logo');
    if (!img) return null;

    var width = img.getAttribute('width');
    var holder = document.createElement('span');
    holder.className = 'neo-logo neo-logo--' + LOGO_ANIM;
    holder.setAttribute('role', 'img');
    holder.setAttribute('aria-label', img.getAttribute('alt') || 'NEO');
    holder.style.width = width ? width + 'px' : '100%';
    holder.style.maxWidth = '100%';
    holder.innerHTML = markup(LOGO_ANIM);

    img.replaceWith(holder);
    return holder;
  }

  function play(el) {
    if (!el || REDUCED) return;
    el.classList.remove('neo-run');
    void el.offsetWidth;          // force reflow so the animation restarts
    el.classList.add('neo-run');
  }

  function initLogo() {
    if (document.querySelector('.neo-logo')) return;   // already swapped
    if (!readSource()) return;                         // no source, leave the PNG alone

    var logo = buildLogo();
    if (!logo) return;

    play(logo);

    var link = logo.closest('a') || logo.parentElement;
    if (!link) return;

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      link.addEventListener('mouseenter', function () { play(logo); });
    } else {
      // phones have no hover, so replay on touch without blocking the link
      link.addEventListener('touchstart', function () { play(logo); }, { passive: true });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* 2. Sticky header condense                                              */
  /* ---------------------------------------------------------------------- */

  function initHeader() {
    var THRESHOLD = 40;
    var ticking = false;
    var on = false;

    function update() {
      var should = window.scrollY > THRESHOLD;
      if (should !== on) {
        on = should;
        document.body.classList.toggle('neo-header-condensed', on);
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  /* ---------------------------------------------------------------------- */
  /* 3. "Get on the list" jump                                              */
  /*    Shopify prefixes section ids with the template id, so a hand-written */
  /*    #shopify-section-... anchor never resolves. Link to #neo-notify and  */
  /*    let this find the signup wherever it is on the page.                 */
  /* ---------------------------------------------------------------------- */

  function initNotifyJump() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href$="#neo-notify"]') : null;
      if (!a) return;

      var target = document.querySelector('.neo-notify') ||
                   document.querySelector('.newsletter') ||
                   document.querySelector('.footer-block__newsletter');
      if (!target) return;   // nothing to jump to, let the link behave normally

      e.preventDefault();
      target.scrollIntoView({
        block: 'center',
        behavior: REDUCED ? 'auto' : 'smooth'
      });

      var field = target.querySelector('input[type="email"]');
      if (field) {
        window.setTimeout(function () { field.focus({ preventScroll: true }); }, REDUCED ? 0 : 450);
      }
    });
  }

  /* ---------------------------------------------------------------------- */
  /* 4. Page transition — fade out on navigation instead of flashing white  */
  /* ---------------------------------------------------------------------- */

  function initTransition() {
    if (REDUCED) return;
    if (document.querySelector('.neo-fade')) return;

    var veil = document.createElement('div');
    veil.className = 'neo-fade';
    document.body.appendChild(veil);

    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;

      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (a.host && a.host !== window.location.host) return;
      if (a.pathname === window.location.pathname && a.search === window.location.search) return;

      document.body.classList.add('neo-leaving');
    });

    // returning through the back/forward cache must not leave the veil up
    window.addEventListener('pageshow', function () {
      document.body.classList.remove('neo-leaving');
    });
  }

  /* ---------------------------------------------------------------------- */

  function boot() {
    initLogo();
    initHeader();
    initNotifyJump();
    initTransition();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // the theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', function () {
    initLogo();
  });
})();
